import React, { Fragment, PureComponent } from 'react';
import { observer, inject } from 'mobx-react';
import Alert from 'react-s-alert';
import PropTypes from 'prop-types';
import themes, { overrides } from '../../themes';
import { Grid, withStyles, Paper, AppBar, IconButton } from '@material-ui/core';
import _ from 'lodash';
import socketIOClient from 'socket.io-client';

import Loader from '../../components/Loader/LoaderView';
// import moment from "moment";
import CustomContentTemplate from './components/Alert/CustomContentTemplate';
import 'font-awesome/css/font-awesome.min.css';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';
import config from '../../config';
import Sound from 'react-sound';
import soundCritical from '../../sound/presense/critical-alert.mp3';
import soundWarning from '../../sound/presense/warning-alert-new.mp3';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage } from '../../utils/common';
import { createMuiTheme } from '@material-ui/core/styles';
import ContentRow from './components/Table/ContentRow';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { sortByPriorityNew, sortFixedEmergency } from './Sortting';
import { hasAlertType } from '../../utils/voteAlert';
import { fixedEmergencyDate } from '../../utils/timeFormatted';
import moment from 'moment';

export class SecurityGuard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      module: 0,
      group: 0,
      page: 0,
      sort: 'showAll',
      setTooltipTitle: '',
      setTooltipOpen: false,
      isDisplayFixedEmergency: true,
      table: {
        seeBoxColor: false,
        seeHN: false,
        seeName: false,
        seeRoom: false,
        seeAction: false,
        seeStatus: false,
        seeAlert: false,
        seeAlertTime: false,
        seeOption: false,
      },
    };
    this.socket = null;
    this.handleTenantChanged = this.handleTenantChanged.bind(this);
  }

  async handleTenantChanged() {
    this.props.dashboard.resetFixedEmergencyAlarm();

    const host = window.location.hostname;
    if (host.includes('dip.airpresense.tech')) {
      localStorage.setItem('select_group', 3);
      localStorage.setItem('select_module', JSON.stringify([39]));
    }

    const tenantId = +localStorage.getItem('select_tenant');
    const subGroupPermission = localStorage.getItem('subgroup_permission')
      ? JSON.parse(localStorage.getItem('subgroup_permission'))
      : null;
    if (subGroupPermission) {
      let subGroups = await this.props.subGroup.getBasicSubgroupInfoByTenantId(tenantId);
      subGroups = (subGroups || []).filter((s) => subGroupPermission.includes(s.id)).map((v) => v.id);
      localStorage.setItem('select_module', JSON.stringify(subGroups));
    }

    if (localStorage.getItem('select_module')) {
      this.setState({ module: localStorage.getItem('select_module') });
      await this.initBed(localStorage.getItem('select_module'));
      await this.unSubscribeToServer();
      this.subscribeToServer();

      if (localStorage.getItem('select_tenant')) {
        this.props.dashboard.getLastFixedEmergencyAlarm([+localStorage.getItem('select_tenant')]);
      }
      await this.props.acknowledge.getAcknowledge();

      setTimeout(() => {
        this.actionChanges();
      }, 0);
    }
  }
  async componentDidMount() {
    document.addEventListener('TenantChanged', this.handleTenantChanged);

    this.props.dashboard.resetFixedEmergencyAlarm();
    this.handleViewPage();
    await this.props.area.getAreas();
    await this.props.router.getRouters();
    let sortData = localStorage.getItem('sort');
    if (!localStorage.getItem('sort')) {
      localStorage.setItem('sort', 'priority-new');
    } else {
      localStorage.setItem('sort', sortData);
    }
    this.props.dashboard.updateToken();

    this.setState({
      page: 1,
      list: 'listview',
      sort: localStorage.getItem('sort'),
    });

    const tenantPermission = +localStorage.getItem('select_tenant');
    const groupPermission = localStorage.getItem('group_permission')
      ? JSON.parse(localStorage.getItem('group_permission'))
      : null;

    const subGroupPermission = localStorage.getItem('subgroup_permission')
      ? JSON.parse(localStorage.getItem('subgroup_permission'))
      : null;

    //get group by tenantId
    if (tenantPermission) {
      await this.props.group.getGroupListByPermission([tenantPermission], groupPermission);
    }

    if (groupPermission) {
      const { groups } = this.props.group.toJS();
      if (subGroupPermission.length === 0) {
        //get subgroupIds
        const subgroupIds = [];
        for (const group of groups || []) {
          group.subGroups.forEach((s) => {
            subgroupIds.push(s.id);
          });
        }

        localStorage.setItem('select_module', JSON.stringify(subgroupIds));
      }
    }

    if (!localStorage.getItem('select_module')) {
      if (subGroupPermission) {
        let subGroups = await this.props.subGroup.getBasicSubgroupInfoByTenantId(tenantPermission);
        subGroups = (subGroups || []).filter((s) => subGroupPermission.includes(s.id)).map((v) => v.id);
        localStorage.setItem('select_module', JSON.stringify(subGroups));
      }
    }

    if (localStorage.getItem('select_module')) {
      this.setState({ module: localStorage.getItem('select_module') });
      await this.initBed(localStorage.getItem('select_module'));
      this.subscribeToServer();

      setTimeout(() => {
        this.actionChanges();
      }, 0);
    }

    if (localStorage.getItem('select_tenant')) {
      this.props.dashboard.getLastFixedEmergencyAlarm([+localStorage.getItem('select_tenant')]);
    }
    await this.props.acknowledge.getAcknowledge();
  }

  // async componentDidMount() {
  //   this.handleViewPage();
  //   await this.props.area.getAreas();
  //   await this.props.router.getRouters();
  //   let sortData = localStorage.getItem("sort");
  //   if (!localStorage.getItem("sort")) {
  //     localStorage.setItem("sort", "priority-new");
  //   } else {
  //     localStorage.setItem("sort", sortData);
  //   }
  //   this.props.dashboard.updateToken();

  //   let locationPermission = localStorage.getItem("location_permission");
  //   locationPermission = JSON.parse(locationPermission);
  //   if (locationPermission.length > 0) {
  //     await this.props.group.getGroupListByLocationIds(locationPermission);
  //   }

  //   this.setState({
  //     page: 1,
  //     list: "listview",
  //     sort: localStorage.getItem("sort"),
  //   });

  //   if (localStorage.getItem("select_group")) {
  //     this.setState({ group: localStorage.getItem("select_group") });
  //     let { groups } = this.props.group.toJS();
  //     let groupSelect = (groups || []).find(
  //       (val) => +val.id === +localStorage.getItem("select_group")
  //     );
  //     this.props.subGroup.setSubGroup(
  //       groupSelect ? groupSelect.subGroups || [] : []
  //     );
  //     const subGroupPermission = JSON.parse(
  //       localStorage.getItem("subgroup_permission")
  //     );
  //     if (
  //       subGroupPermission.length > 1 &&
  //       !localStorage.getItem("select_module")
  //     ) {
  //       this.setSelcteAllModules();
  //     }
  //   }
  //   if (
  //     localStorage.getItem("select_group") &&
  //     localStorage.getItem("select_module")
  //   ) {
  //     this.setState({ module: localStorage.getItem("select_module") });
  //     await this.initBed(localStorage.getItem("select_module"));
  //     this.subscribeToServer();
  //   }

  //   setTimeout(() => {
  //     this.actionChanges();
  //   }, 0);
  // }

  async handleViewPage() {
    this.setState({
      table: {
        seeBoxColor: false,
        seeHN: false,
        seeName: true,
        seeRoom: false,
        seeAction: false,
        seeStatus: false,
        seeAlert: true,
        seeAlertTime: true,
        seeOption: true,
      },
    });
  }
  async initBed(subGroupId) {
    await this.props.dashboard.getPatientForSubgroup(subGroupId);
  }

  async initBedNoLoading(subGroupId) {
    await this.props.dashboard.getPatientForSubgroup(subGroupId, false);
  }

  // async setDataChangeList(payloadList, task) {
  //   // const t0 = performance.now()
  //   const { routerNoSignal } = this.props.dashboard.toJS();
  //   (payloadList || []).forEach((data) => {
  //     const payload = task === "init" ? data : data.data;
  //     if (payload.routerSerial && payload.deviceSerial === "") {
  //       if (payload.alerts && payload.alerts.length > 0) {
  //         payload.alerts.forEach(a => {
  //           if (a.alertType === 505 && a.alertWarning === 'true') {
  //             let router = routerNoSignal.find(
  //               (val) => val.routerId === payload.routerSerial
  //             );
  //             if (!router) {
  //               this.props.dashboard.setAlertRouter(
  //                 payload.routerSerial,
  //                 "alertDb"
  //               );
  //             }
  //           } else {
  //             let router = routerNoSignal.find(
  //               (val) => val.routerId === payload.routerSerial
  //             );
  //             if (router) {
  //               this.props.dashboard.resetAlertRouter(payload.routerSerial);
  //             }
  //           }
  //         });
  //       }
  //     }
  //     if (payload.deviceSerial.length > 0 && payload.alerts && payload.alerts.length > 0 ) {
  //       // checking for fixed emergency
  //       this.setState({ isDisplayFixedEmergency: true});
  //       payload.alerts.forEach((a) => {
  //         if (!payload.patientId && a.alertType === 514) {
  //           this.props.dashboard.setPayloadFixedEmegencyAlarm(payload);
  //         }
  //       });
  //       // payload.alerts.forEach(a => {
  //       //   if (!payload.patientId && a.alertType === 514) {
  //       //     if (a.alertCritical === "true") {
  //       //       Alert.success("Header", {
  //       //         customFields: {
  //       //           type: "critical",
  //       //           alertType: 514,
  //       //         },
  //       //         position: "top-right",
  //       //         timeout: "none",
  //       //       });
  //       //     }
  //       //   }
  //       // })
  //     }
  //   });
  //   try {
  //     this.props.dashboard.setPayloadList(payloadList, task);
  //   } catch (e) {
  //     console.log("error : payloadList", payloadList);
  //   }
  //   // const t1 = performance.now()
  //   // console.log(" setDataChangeList time " + (t1 - t0) + " milliseconds.")
  // }

  async setDataChangeList(payloadList, task) {
    // const t0 = performance.now()
    const { routerNoSignal } = this.props.dashboard.toJS();
    (payloadList || []).forEach((data) => {
      const payloads = task === 'init' ? data : data.data;
      (payloads.notifications || []).forEach((payload) => {
        // checking for router nosignal status
        if (payload.routerSerial && payload.deviceSerial === '') {
          if (payload.alerts && payload.alerts.length > 0) {
            payload.alerts.forEach((a) => {
              if (a.alertType === 505 && a.alertWarning === 'true') {
                let router = routerNoSignal.find((val) => val.routerId === payload.routerSerial);
                if (!router) {
                  this.props.dashboard.setAlertRouter(payload.routerSerial, 'alertDb');
                }
              } else {
                let router = routerNoSignal.find((val) => val.routerId === payload.routerSerial);
                if (router) {
                  this.props.dashboard.resetAlertRouter(payload.routerSerial);
                }
              }
            });
          }
        } else if (
          payload.deviceSerial.length > 0 &&
          !payload.patientId &&
          payload.alerts &&
          payload.alerts.length > 0 &&
          payload.alerts[0].alertType === 514
        ) {
          // checking for fixed emergency
          this.setState({ isDisplayFixedEmergency: true });
          this.props.dashboard.setPayloadFixedEmegencyAlarm(payload);
        }
      });
    });

    try {
      this.props.dashboard.setPayloadList(payloadList, task);
    } catch (e) {
      console.log('error : payloadList', payloadList);
    }
  }

  async setDataChange(payload, task) {
    const { user, routerNoSignal } = this.props.dashboard.toJS();
    /// Start set status router ///
    if (task === 'realtime') {
      if (payload.routerSerial && payload.deviceSerial === '') {
        if (payload.alertInfo === 'No Signal') {
          let router = routerNoSignal.find((val) => val.routerId === payload.routerSerial);
          if (!router) {
            this.props.dashboard.setAlertRouter(payload.routerSerial, 'alertDb');
          }
        } else {
          let router = routerNoSignal.find((val) => val.routerId === payload.routerSerial);
          if (router) {
            this.props.dashboard.resetAlertRouter(payload.routerSerial);
          }
        }
      } else if (payload.routerSerial && payload.deviceSerial) {
        if (payload.alertCritical !== 'true' && payload.alertWarning !== 'true') {
          let router = routerNoSignal.find((val) => val.routerId === payload.routerSerial);
          if (router) {
            this.props.dashboard.resetAlertRouter(payload.routerSerial);
          }
        }
      }
    }
    /// End set status router ///

    // Find device in page //
    let dataUser = _.find(user, (element) => {
      if (element.patient) {
        return _.find(element.patient.devices, (device) => {
          return device.serial === payload.deviceSerial && device.status === 'ACTIVATE_ON';
        });
      }
    });
    // End Find device in page //

    if (dataUser && payload) {
      try {
        // set alert
        if (payload.alertType) {
          let eventPriority = payload.alertCritical === 'true' ? 'critical' : 'warning';
          this.props.dashboard.setAlert(payload, eventPriority);
        } else {
          const changed = JSON.parse(payload.changed);
          if (changed.a || changed.f === 0 || changed.f === 1 || changed.f === 2) {
            this.props.dashboard.clearAlert(payload.deviceSerial);
          }
        }
        if (payload.changed) {
          // set change
          const changed = JSON.parse(payload.changed);
          if (
            (changed.a && this.validateChange('a', changed.a)) ||
            (changed.f !== null &&
              changed.f !== '' &&
              changed.f !== undefined &&
              this.validateChange('f', changed.f)) ||
            changed.b
            // || (changed.m && payload.alertWarning === 'true' && !changed.a)
          ) {
            this.props.dashboard.setAction(payload);
            if (localStorage.getItem('role_id') === '1' && task === 'realtime') {
              // set logs activity
              if ((changed.f && changed.f === 3) || changed.a || (changed.b < 20 && payload.alertWarning === 'true')) {
                // const { patient } = this.props.dashboard.getAlertID(
                //   payload.deviceSerial
                // );
                // let activity = changed.f === 3 ? 12 : changed.a;
                // if (changed.b < 20 && payload.alertWarning === 'true') {
                //   activity = 8;
                // }
                // if (payload.deviceSerial) {
                //   const dataLogActivity = {
                //     id: Math.floor((Math.random() * 10000000) + 1),
                //     variant: payload.alertCritical === 'true' ? 'error' : payload.alertWarning === 'true' ? 'warning' : 'primary',
                //     time: moment().format(),
                //     action: this.getMomentValue(activity),
                //     patient: patient,
                //     activity: activity,
                //     router: payload.routerSerial || '',
                //     deviceSerial: payload.deviceSerial || ''
                //   }
                //   this.props.logActivity.addActivity(dataLogActivity);
                // }
              }
            }
          }
        }
      } catch (e) {
        console.log('error : payload', payload);
      }
    }
  }

  async actionChanges() {
    const { user } = this.props.dashboard.toJS();
    let serials = [];
    (user || []).forEach((data) => {
      if (data.patient) {
        serials = [...serials, ...(data.patient.devices || []).map((item) => item.serial)];
      }
    });

    const lastAction = await this.props.dashboard.lastActivity(serials, false);
    if (lastAction && lastAction.length > 0) {
      let numLoop = [];
      for (let i = 0; i < lastAction.length; i += 50) {
        numLoop.push(i);
      }
      for (const item of numLoop) {
        this.setDataChangeList(lastAction.slice(item, item + 50), 'init');
      }
    }
  }

  async subscribeToServer() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket.close();
      this.socket = null;
    }

    this.socket = socketIOClient(`${config.api.url_socket}`);

    // subscribe tenant
    const tenantId = localStorage.getItem('select_tenant');
    if (tenantId) {
      this.socket.on(`tenant_alert_${tenantId}`, async (payload) => {
        // console.log('payload tenant alert ---> ',payload);
        await this.setPayload(payload);
      });

      this.socket.on(`tenant_acknowledge_${tenantId}`, async (payload) => {
        // console.log('payload tenant acknowledge ---> ',payload);
        await this.setPayload(payload);
      });
    }

    if (localStorage.getItem('select_module')) {
      const selectModule = JSON.parse(localStorage.getItem('select_module'));
      (selectModule || []).forEach((val) => {
        this.socket.on(`module_alert_${val}`, async (payload) => {
          // console.log('payload alert ---> ',payload);
          await this.setPayload(payload);
        });
        this.socket.on(`module_acknowledge_${val}`, async (payload) => {
          // console.log('payload acknowledge ---> ',payload);
          await this.setPayload(payload);
        });
        this.socket.on(`module_fetch_${val}`, async (payload) => {
          // console.log('payload fetch ---> ',payload);
          await this.setPayload(payload);
        });
      });
    }
    if (localStorage.getItem('select_group')) {
      const selectedGroupId = JSON.parse(localStorage.getItem('select_group'));
      let { groups } = this.props.group.toJS();
      let groupSelect = (groups || []).find((val) => +val.id === selectedGroupId);
      (groupSelect.subGroups || []).forEach((val) => {
        this.socket.on(`module_alert_router_no_signal_${val.id}`, async (payload) => {
          await this.setPayload(payload);
        });
      });
    }
  }

  async unSubscribeToServer() {
    // FCM
    if (config.firebase.status && localStorage.getItem('fcm_token')) {
      if (localStorage.getItem('select_module')) {
        const selectModule = JSON.parse(localStorage.getItem('select_module'));
        for (const val of selectModule || []) {
          console.log(`unSubscribeFCM Topic : ${val}_module_alert`);
          await this.props.fcm.unSubscribeFCM(localStorage.getItem('fcm_token'), `${val}_module_alert`);
          await this.props.fcm.unSubscribeFCM(localStorage.getItem('fcm_token'), `${val}_module_acknowledge`);
        }
      }
    }
  }

  getNotificationAlert(id) {
    return [
      `module_alert_getup_${id}`,
      `module_alert_movement_${id}`,
      `module_alert_row_battery_${id}`,
      `module_alert_device_no_signal_${id}`,
      `module_alert_router_no_signal_${id}`,
      `module_alert_not_turn_for_${id}`,
      `module_alert_no_movement_for_${id}`,
      `module_alert_fall_${id}`,
      `module_alert_out_of_area_${id}`,
      `module_alert_into_of_area_${id}`,
      `module_alert_walking_at_night_${id}`,
      `module_alert_recharge_battery_${id}`,
      `module_alert_device_bad_signal_${id}`,
      `module_alert_emergency_alarm_${id}`,
    ];
  }

  async setPayload(payload) {
    // const dashboard = this;
    if (payload.length > 0) {
      if (config.groupNotification) {
        await this.setDataChangeList(payload, 'realtime');
      } else {
        // const datanotifyAPIStart = +payload.data.apiStart
        // const dataDisplayWebStart = +Date.now()
        // const time = {};
        // time.package10 = dataDisplayWebStart - datanotifyAPIStart
        // if (time.package10 < 10000) {
        //   const { dbStatus } = dashboard.props.dashboard.toJS();
        //   if (payload.data.dbStatus === 'true') {
        //     if (dbStatus.status === false && dbStatus.id) {
        //       Alert.close(dbStatus.id);
        //       dashboard.props.dashboard.resetDbStatus();
        //     }
        //   } else {
        //     if (dbStatus.status === true && dbStatus.id === null) {
        //       let alertDb = Alert.error('Header', {
        //         customFields: {
        //           dbStatus: false,
        //         },
        //         position: 'bottom',
        //         timeout: 'none',
        //         type: 'critical'
        //       });
        //       dashboard.props.dashboard.setAlertDb(alertDb);
        //     }
        //   }
        //   this.setDataChange(payload.data, 'realtime');
        // }
      }
    } else {
      // sync data
      if (payload.data && payload.data.type) {
        if (payload.data && (payload.data.type === 'group' || payload.data.type === 'subgroup')) {
          // redirect login
          this.signOut();
          window.location.replace('/login');
        } else if (payload.data && payload.data.type === 'acknowledge') {
          const acknowledgeFor = payload.data.prevNotification;
          Alert.success('Header', {
            customFields: {
              dbStatus: true,
              type: 'info',
              userName: payload.data.userName,
              patient: payload.data.patient,
              notification: acknowledgeFor,
            },
            position: 'top-right',
            timeout: 3000,
          });
          const acknowledge = {
            notification: acknowledgeFor,
            patient: payload.data.patient,
            user: {
              userName: payload.data.userName,
            },
            createdDate: Date.now(),
            unRead: true,
          };
          this.props.acknowledge.addAcknowledge(acknowledge);

          const newNotification = {
            patientId: payload.data.patient ? payload.data.patient.id : null,
            subGroupId: payload.data.subGroupId,
            notifications: payload.data.newNotification,
          };
          this.props.dashboard.setPayloadFixedEmegencyAlarm(newNotification, 'acknowledge');
          await this.setDataChangeList([{ data: newNotification }], 'realtime');
          // await this.initBedNoLoading(localStorage.getItem("select_module"));
          // this.actionChanges();
        } else if (payload.data && payload.data.type === 'changePassword') {
          if (localStorage.getItem('user') === payload.data.userName) {
            clearLocalStorage();
            window.location.href = '/login';
          }
        } else {
          await this.initBed(localStorage.getItem('select_module'));
          this.actionChanges();
        }
      }
    }
  }

  getMomentValue = (value) => {
    const { t } = this.props;
    let result = `${t('unknown')}`;
    switch (value) {
      case 1:
        result = `${t('lying')}`;
        break;
      case 2:
        result = `${t('sitting')}`;
        break;
      case 3:
        result = `${t('standing')}`;
        break;
      case 4:
        result = `${t('walking')}`;
        break;
      case 5:
        result = `${t('Running')}`;
        break;
      case 6:
        result = `${t('Jumping')}`;
        break;
      case 7:
        result = `${t('movement')}`;
        break;
      case 8:
        result = `${t('low_battery')}`;
        break;
      case 9:
        result = `${t('no_signal')}`;
        break;
      case 10:
        result = `${t('not_turn_for')}`;
        break;
      case 11:
        result = `${t('no_movement')}`;
        break;
      case 12:
        result = `${t('falling')}`;
        break;
      case 13:
        result = `${t('unknown')}`;
        break;
      case 14:
        result = `${t('lying_on_back')}`;
        break;
      case 15:
        result = `${t('lying_on_stomach')}`;
        break;
      case 16:
        result = `${t('lying_on_left_side')}`;
        break;
      case 17:
        result = `${t('lying_on_right_side')}`;
        break;
      case 18:
        result = `${t('out_of_area')}`;
        break;
      case 19:
        result = `${t('walking_at_night')}`;
        break;
      case 100:
        result = `${t('detect_location')}`;
        break;
      default:
        break;
    }
    return result;
  };

  getRouterPlace = (serial) => {
    const { routers } = this.props.router.toJS();
    const routerData = (routers || []).find((val) => val.serial === serial);
    if (routerData) {
      return routerData.place;
    }
  };

  getRouterArea = (serial) => {
    let { areas } = this.props.area.toJS();
    let name = '';
    (areas.data || []).map((val) => {
      const result = (val.routers || []).find((routers) => routers.serial === serial);
      if (result) {
        name = val.name;
      }
      return val;
    });
    return name;
  };

  getAlertInfo = (value, serial, time, alertAreaName) => {
    const { t } = this.props;
    let numberOfDay = time / 60 / 24;
    let dayFormat = `${numberOfDay === 1 ? numberOfDay + ' ' + t('day') : numberOfDay + ' ' + t('days')}`;
    let result = `${t('unknown')}`;
    switch (value) {
      case 1:
        result = `${t('lying')}`;
        break;
      case 2:
        result = `${t('sitting')}`;
        break;
      case 3:
        result = `${t('standing')}`;
        break;
      case 4:
        result = `${t('walking')}`;
        break;
      case 5:
        result = `${t('Running')}`;
        break;
      case 6:
        result = `${t('Jumping')}`;
        break;
      case 7:
        result = `${t('lying_on_back')}`;
        break;
      case 8:
        result = `${t('lying_on_stomach')}`;
        break;
      case 9:
        result = `${t('lying_on_left_side')}`;
        break;
      case 10:
        result = `${t('lying_on_right_side')}`;
        break;
      case 501:
        result = `${t('get_up')}`;
        break;
      case 502:
        result = `${t('movement')}`;
        break;
      case 503:
        result = `${t('low_battery')}`;
        break;
      case 504:
        result = `${t('alert_last_seen')} @ ${this.getRouterPlace(serial)}`;
        break;
      case 505:
        result = `${t('alert_router_no_signal')}`;
        break;
      case 506:
        result = `${t('alert_not_turn')}`;
        break;
      case 507:
        result = `${t('alert_no_movement')} > ${numberOfDay === 0 ? '' : dayFormat}`;
        break;
      case 508:
        result = `${t('alert_fall')} @ ${this.getRouterPlace(serial)}`;
        break;
      case 509:
        result = ` @ ${t('alert_exit')} ${alertAreaName ? alertAreaName : this.getRouterArea(serial)}`;
        break;
      case 510:
        result = ` @ ${alertAreaName ? alertAreaName : this.getRouterArea(serial)}`;
        break;
      case 511:
        result = `${t('alert_walking')} @ ${this.getRouterPlace(serial)}`;
        break;
      case 512:
        result = `${t('alert_deactivate_recharge')}`;
        break;
      case 513:
        result = `${t('alert_bad_signal')}`;
        break;
      case 514:
        result = `${t('alert_emergency_alarm')}`;
        break;
      default:
        break;
    }
    return result;
  };

  async setSelcteAllModules() {
    let subgroupAll = [];
    let { ListSubGroups } = this.props.subGroup.toJS();

    if (localStorage.getItem('role_id') !== '1') {
      const subGroupPermission = JSON.parse(localStorage.getItem('subgroup_permission'));
      ListSubGroups = (ListSubGroups || []).filter((val) => subGroupPermission.includes(val.id));
    }

    ListSubGroups.forEach((val) => {
      subgroupAll.push(val.id);
    });
    subgroupAll.sort((a, b) => a - b);
    subgroupAll = JSON.stringify(subgroupAll);

    localStorage.setItem('select_module', subgroupAll);
    this.setState({ module: localStorage.getItem('select_module') });
    await this.initBed(localStorage.getItem('select_module'));
    this.subscribeToServer();
    this.props.patient.findMapBySubgroupIds(localStorage.getItem('select_module'));
    const subgrouplist = JSON.parse(subgroupAll);
    if (subgrouplist.length > 0) {
      const selectedSubGroup = ListSubGroups.find((val) => val.id === subgrouplist[0]);
      localStorage.setItem(
        'subgroup_type',
        selectedSubGroup && selectedSubGroup.type ? selectedSubGroup.type : 'hospital',
      );
    }
  }

  validateChange(task, value) {
    if (task === 'a') {
      switch (value) {
        // case 1: case 2: case 3: case 4: case 5: case 6: case 8: case 9: case 10: case 11: case 14: case 15: case 16: case 17: case 18: case 19:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 14:
        case 15:
        case 16:
        case 17:
        case 100:
          return true;
        default:
          return false;
      }
    }
    if (task === 'f') {
      switch (value) {
        case 0:
        case 1:
        case 2:
        case 3:
          return true;
        default:
          return false;
      }
    }
    if (task === 'b') {
      return true;
    }
    if (task === 'm') {
      return true;
    }
  }

  // clearAlert(deviceSerial) {
  //   this.props.dashboard.clearAlert(deviceSerial);
  // }

  // acknowledge(deviceSerial) {
  //   this.props.dashboard.ackAlert(deviceSerial);
  // }

  acknowledgeFixedEmegency(data) {
    this.props.dashboard.updateToken();
    const alerts = (data.alerts || []).map((a) => {
      return {
        alertId: a.alertId,
        alertType: a.alertType,
      };
    });
    this.props.dashboard.ackFixedEmergency(data, alerts);
  }

  async signOut() {
    localStorage.removeItem('id_token');
    localStorage.removeItem('role');
    localStorage.removeItem('role_id');
    localStorage.removeItem('user');
    localStorage.removeItem('user_id');
    localStorage.removeItem('fcm_token');
    localStorage.removeItem('location_permission');
    localStorage.removeItem('group_permission');
    localStorage.removeItem('subgroup_permission');
    localStorage.removeItem('select_module');
    localStorage.removeItem('select_group');
    localStorage.removeItem('subgroup_type');
    localStorage.removeItem('sort');
    localStorage.removeItem('last_view');
    localStorage.removeItem('tenantInfo');
    localStorage.removeItem('tenant_permission');
  }

  getMuiTheme = () =>
    createMuiTheme({
      ...themes.list,
      ...overrides,
      typography: {
        fontFamily: ['Kanit', 'sans-serif'].join(','),
        useNextVariants: true,
      },
    });

  validateTableRow = (data, expectedSize) => {
    return data && Array.isArray(data) && data.length === expectedSize;
  };

  getFullname = (language, data, arraySize) => {
    let fullname = '';
    const validateTableRow = Boolean(this.validateTableRow(data, arraySize));

    if (language && language === 'th-TH' && validateTableRow) {
      if (data[3] || data[4]) {
        fullname = `${data[3] ?? ''} ${data[4] ?? ''}`;
      } else {
        fullname = `${data[17] ?? ''} ${data[18] ?? ''}`;
      }
    }

    if (language && language === 'en-EN' && validateTableRow) {
      if (data[17] || data[18]) {
        fullname = `${data[17] ?? ''} ${data[18] ?? ''}`;
      } else {
        fullname = `${data[3] ?? ''} ${data[4] ?? ''}`;
      }
    }

    if (language && (language === 'th-TH' || language === 'en-EN') && validateTableRow && !data[3] && !data[4]) {
      fullname = '';
    }

    return fullname;
  };

  getFirstname = (language, data) => {
    let firstname = '';
    if (language && language === 'th-TH') {
      if (data.firstname) {
        firstname = data.firstname;
      } else {
        firstname = data.firstnameEn;
      }
    }
    if (language && language === 'en-EN') {
      if (data.firstnameEn) {
        firstname = data.firstnameEn;
      } else {
        firstname = data.firstname;
      }
    }
    return firstname;
  };

  getColumn = (users) => {
    const { classes, t } = this.props;
    return (
      <Paper className={classes.paperList}>
        <Table aria-label='simple table'>
          <TableHead>
            <TableRow className={classes.headTable}>
              <TableCell className={classes.tableCell} />
              <TableCell className={classes.tableCell} align='left'>
                {t('name')}
              </TableCell>
              <TableCell className={classes.tableCell} align='left'>
                {t('alert')}
              </TableCell>
              <TableCell className={classes.tableCell} align='left'>
                {t('time')}
              </TableCell>
              <TableCell className={classes.tableCell} align='left'>
                {t('options')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((row, index) => (
              <ContentRow data={row} key={index} showTable={this.state.table} />
            ))}
          </TableBody>
        </Table>
      </Paper>
    );
  };

  isMuted = (userWithAlert, isCritical) => {
    let muteNotification = localStorage.getItem('mute_notification');
    muteNotification = muteNotification ? JSON.parse(muteNotification) : [];
    const mutePatient = muteNotification.find((val) => val.patientId === userWithAlert.patientId);
    if (mutePatient) {
      if (
        userWithAlert &&
        userWithAlert.patient &&
        userWithAlert.patient.devices &&
        userWithAlert.patient.devices.length > 0
      ) {
        // const alertIds = (userWithAlert.patient.devices).filter(a => a.action && a.action.alertId && (isCritical ? a.action.alertCritical === 'true' : a.action.alertWarning === 'true')).map(a => a.action && a.action.alertId);
        const alertIds = [];
        userWithAlert.patient.devices.forEach((d) => {
          if (d.action && d.action.alerts.length > 0) {
            d.action.alerts.forEach((a) => {
              if (a.alertId && a.alertType !== 513) {
                alertIds.push(a.alertId);
              }
            });
          }
        });
        const newAlertIds = alertIds.filter((x) => !(mutePatient.alertId || []).includes(x));
        return newAlertIds.length === 0 ? true : false;
      }
    }
    return false;
  };

  handleDisplayFixedEmergency = () => {
    this.setState({
      isDisplayFixedEmergency: !this.state.isDisplayFixedEmergency,
    });
  };

  render() {
    const { classes, t } = this.props;
    let dashboard = this.props.dashboard.toJS();
    const patient = this.props.patient.toJS();
    let subGroup = this.props.subGroup.toJS();
    const group = this.props.group.toJS();

    let subList = subGroup.ListSubGroups;

    let usersData = dashboard.user.filter((item) => {
      return item.patient;
    });
    usersData.map((item) => {
      let fullname = '';
      if (localStorage.getItem('i18nextLng') && localStorage.getItem('i18nextLng') === 'th-TH') {
        if (item.patient.firstname || item.patient.lastname) {
          fullname = `${item.patient.firstname ?? ''} ${item.patient.lastname ?? ''}`;
        } else {
          fullname = `${item.patient.firstnameEn ?? ''} ${item.patient.lastnameEn ?? ''}`;
        }
      }
      if (localStorage.getItem('i18nextLng') && localStorage.getItem('i18nextLng') === 'en-EN') {
        if (item.patient.firstnameEn || item.patient.lastnameEn) {
          fullname = `${item.patient.firstnameEn ?? ''} ${item.patient.lastnameEn ?? ''}`;
        } else {
          fullname = `${item.patient.firstname ?? ''} ${item.patient.lastname ?? ''}`;
        }
      }
      item.fullname = fullname;
      return item;
    });

    if (localStorage.getItem('role_id') !== '1') {
      let subgroupPermission = localStorage.getItem('subgroup_permission');
      subgroupPermission = JSON.parse(subgroupPermission);

      subList = subGroup.ListSubGroups.filter((s) => {
        const found = (subgroupPermission || []).find((f) => f === s.id);
        return found ? true : false;
      });
    }

    let subgroupAll = [];
    subList.forEach((val) => {
      subgroupAll.push(val.id);
    });
    subgroupAll.sort((a, b) => a - b);
    subgroupAll = JSON.stringify(subgroupAll);

    // filter alert //
    dashboard.user = dashboard.user.filter(
      (val) =>
        val.patient &&
        val.patient.devices &&
        val.patient.devices.length > 0 &&
        val.patient.devices.find(
          (d) => d.action && d.action.alerts.length > 0 && d.action.alerts.find((a) => a.alertType !== 513),
        ),
    );

    /// Sort priority-new ///
    if (localStorage.getItem('sort') === 'priority-new') {
      dashboard.user = sortByPriorityNew(dashboard.user, localStorage.getItem('i18nextLng'));
    }

    // show maximum 10 bed
    dashboard.user = dashboard.user.slice(0, 10);
    /// End Sort room bad and patient ///

    const AlertCritical =
      dashboard.fixedEmergency.length > 0
        ? true
        : dashboard.user.find(
            (val) =>
              val.patient &&
              val.patient.devices &&
              hasAlertType(val.patient.devices, 'alertCritical') &&
              !this.isMuted(val, true),
          );
    const AlertWarning = !AlertCritical
      ? dashboard.user.find(
          (val) =>
            val.patient &&
            val.patient.devices &&
            hasAlertType(val.patient.devices, 'alertWarning') &&
            !this.isMuted(val, false),
        )
      : null;

    dashboard.fixedEmergency = sortFixedEmergency(dashboard.fixedEmergency);

    let noOfFixedEmergency = 0;
    (dashboard.fixedEmergency || []).forEach((e) => {
      if (e.notifications.length > 0) {
        e.notifications.forEach((n) => {
          noOfFixedEmergency += n.alerts.length;
        });
      }
    });

    return (
      <Fragment>
        <Loader loading={dashboard.loading || patient.loading || subGroup.loading || group.loading} />
        <Sound
          position={1}
          url={soundCritical}
          playStatus={AlertCritical ? Sound.status.PLAYING : Sound.status.STOPPED}
          loop={true}
        />
        <Sound
          position={2}
          url={soundWarning}
          playStatus={AlertWarning ? Sound.status.PLAYING : Sound.status.STOPPED}
          loop={true}
        />
        <Alert contentTemplate={CustomContentTemplate} stack={false} />

        <Grid container alignItems='flex-start'>
          {/* Start ----- ListView */}
          {
            // page === 1 &&
            // localStorage.getItem("select_group") &&
            localStorage.getItem('select_module') && (
              <Fragment>
                <Grid container className={classes.mainContainList}>
                  <Grid item xs={12}>
                    {dashboard.user.length > 0 && this.getColumn(dashboard.user)}
                  </Grid>
                </Grid>
              </Fragment>
            )
          }
          {/* End ----- ListView */}

          {/* ----- fixed emergency phase ----- */}
          <Grid className={classes.fixedAlertPosition} style={{ display: noOfFixedEmergency ? '' : 'none' }}>
            {!this.state.isDisplayFixedEmergency && <div className={classes.fixedAlertMockPosition} />}
            {this.state.isDisplayFixedEmergency && (
              <Paper className={classes.fixedAlertBox}>
                <div className={classes.widgetHeader}>
                  <AppBar position='static' className={classes.headerToolbar}>
                    <Grid container>
                      <div className={classes.titleHeader}>{t('location_based_alert')}</div>
                      <div className={classes.iconMinimize} onClick={this.handleDisplayFixedEmergency}>
                        <svg width='18' height='18' viewBox='0 0 18 18'>
                          <use xlinkHref={`/images/menus-v1.svg#minimize`} />
                        </svg>
                      </div>
                    </Grid>
                  </AppBar>
                </div>
                <div className={classes.fixedAlertContent}>
                  {dashboard.fixedEmergency &&
                    dashboard.fixedEmergency.length > 0 &&
                    dashboard.fixedEmergency.map((e) => (
                      <div key={e.date}>
                        <div style={{ fontSize: 14, fontWeight: 400 }}>{fixedEmergencyDate(e.date, t)}</div>
                        <hr className={classes.dividers} />
                        {(e.notifications || []).map((noti, i) =>
                          (noti.alerts || []).map((a) => (
                            <Grid container key={i} style={{ marginBottom: 10, marginTop: 10 }}>
                              <Grid container item sm={10}>
                                <div style={{ width: '15%' }}>
                                  <svg width='28' height='28' viewBox='0 0 84 83'>
                                    <use xlinkHref={`/images/sos-v4.svg#fixed`} />
                                  </svg>
                                </div>
                                <div className={classes.fixedAlertTime}>{moment(a.alertTime).format('HH:mm')}</div>
                                <div className={classes.alertPlace}>{a.alertFixedEmergencyPlace}</div>
                              </Grid>
                              <Grid container item sm={2} style={{ justifyContent: 'right' }}>
                                <IconButton
                                  classes={{ root: classes.btnAck }}
                                  aria-label='delete'
                                  id='acknowledge'
                                  onClick={() => this.acknowledgeFixedEmegency(noti)}
                                >
                                  <svg
                                    width='21'
                                    height='21'
                                    viewBox='0 0 21 21'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                    className={classes.btnAckCritical}
                                  >
                                    <path d='M6.5 11L9 14L15.5 6' strokeWidth='1.5' />
                                  </svg>
                                </IconButton>
                              </Grid>
                            </Grid>
                          )),
                        )}
                      </div>
                    ))}
                </div>
              </Paper>
            )}
            <IconButton className={classes.buttonFixedEmergency} onClick={this.handleDisplayFixedEmergency}>
              <svg width='60' height='60' viewBox='0 0 84 83'>
                <use xlinkHref={`/images/sos-v4.svg#fixed`} />
              </svg>
              <label
                className='badge badge-primary-sos'
                style={{
                  display: noOfFixedEmergency ? '' : 'none',
                }}
              >
                {noOfFixedEmergency}
              </label>
            </IconButton>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

const styles = (theme) => ({
  butttonOption: {
    padding: '3px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  columnWidth250: {
    maxWidth: '250px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  icongender: {
    fontSize: '16px',
    marginRight: theme.spacing.unit * 2,
    color: theme.palette.primary.main,
  },

  tooltipFont: {
    fontSize: '15px',
  },
  paperList: {
    overflowX: 'auto',
    padding: '10px 20px',
  },
  headTable: {
    border: 'none',
    height: 40,
  },
  tableCell: {
    color: theme.palette.text.header,
    borderBottom: '1px solid #B8CFC3',
    padding: '4px',
    // padding: "4px 26px 4px 24px",
  },
  mainContainList: {
    // margin: "7px 15px",
    width: '100%',
    padding: '15px 19px 0px 17px',
  },
  fixedAlertPosition: {
    display: 'flex',
    position: 'fixed',
    right: '2%',
    bottom: '1%',
    zIndex: 1100,
  },
  fixedAlertMockPosition: {
    height: '155px',
  },
  fixedAlertBox: {
    position: 'relative',
    overflow: 'hidden',
    width: '351px',
    height: '155px',
  },
  fixedAlertContent: {
    padding: '7px 17px 7px 20px',
    position: 'relative',
    overflowY: 'scroll',
    height: '115px',
  },
  widgetHeader: {
    paddingBottom: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerToolbar: {
    flexGrow: 1,
    display: 'flex',
    backgroundColor: theme.palette.error.main,
    boxShadow: 'none',
    height: 37,
    padding: '7px 17px',
  },
  titleHeader: {
    width: '90%',
    fontSize: '16px',
    fontWeight: 600,
    color: 'white',
  },
  iconMinimize: {
    width: '10%',
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center',
    cursor: 'pointer',
  },
  btnAck: {
    padding: 0,
    width: 28,
    height: 28,
    color: theme.palette.error.main,
    cursor: 'pointer',
    backgroundColor: 'rgba(235, 88, 97, 0.4)',
    '&:hover': {
      backgroundColor: 'rgba(235, 88, 97, 0.4)',
    },
  },
  btnAckCritical: {
    width: 22,
    stroke: theme.palette.error.main,
  },
  buttonFixedEmergency: {
    top: 50,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  dividers: {
    backgroundColor: 'rgba(9,30,66,0.13)',
    border: 0,
    height: '1px',
    padding: 0,
    margin: '5px 0px',
    width: '100%',
  },
  fixedAlertTime: {
    color: theme.palette.success.main,
    fontWeight: 400,
    fontSize: 16,
    width: '20%',
  },
  alertPlace: {
    color: theme.palette.text.header,
    fontWeight: 600,
    fontSize: 16,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '65%',
  },
});

SecurityGuard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export const page = inject(
  'dashboard',
  'acknowledge',
  'setting',
  'patient',
  'event',
  'router',
  'logActivity',
  'subGroup',
  'maps',
  'group',
  'fcm',
  'screen',
  'device',
  'settingProfile',
  'area',
)(observer(SecurityGuard));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
